import React, { useEffect } from 'react';
import emailjs from 'emailjs-com';

const FooterSend = () => {
  const currentPath = window.location.pathname;
  const currentPageNumber = parseInt(currentPath.replace(/\D/g, ''));
  const nextStep = `/simulacao/${Math.min(currentPageNumber + 1, 10)}`;

  // API Trindade
  const sendApiData = () => {
    const indicacao = {
      Nome: sessionStorage.getItem('@fullName').replace(/^"|"$/g, ''),
      FaixasEtarias: JSON.parse(sessionStorage.getItem('@ageData')),
      FonePrincipal: sessionStorage.getItem('@phone').replace(/["()]/g, ''),
      Modalidade: JSON.parse(sessionStorage.getItem('@plan')).plan,
      PreferenciaHospitalar: JSON.parse(
        sessionStorage.getItem('@preferencesData'),
      ).preferences,
      Email: sessionStorage.getItem('@email').replace(/^"|"$/g, ''),
      Cidade: sessionStorage.getItem('@city').replace(/^"|"$/g, ''),
      PlanoAnteriorNome: sessionStorage.getItem('@providerName'),
      Observacao:
        JSON.stringify(
          'Urgência: ' +
            sessionStorage.getItem('@urgency') +
            '; Método de contato: ' +
            sessionStorage.getItem('@contactMethod') +
            '; Horário de preferência: ' +
            sessionStorage.getItem('@preferredTime') +
            '; Data de video-chamada: ' +
            sessionStorage.getItem('@callDateTime'),
        ) || '',
      IdFonte: 1282,
    };

    fetch('https://api.paineldocorretor.com.br/indicacoes?hash=v0o9AP', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify(indicacao),
    })
      .then((response) => response.json())
      .then((data) => console.log('API response:', data))
      .catch((error) => console.error('API error:', error));
  };

  const sendApiDataIndividual = () => {
    const indicacao = {
      Nome: sessionStorage.getItem('@fullName').replace(/^"|"$/g, ''),
      Idade: JSON.parse(sessionStorage.getItem('@individualData')).age || '',
      FonePrincipal: sessionStorage.getItem('@phone').replace(/["()]/g, ''),
      Modalidade: JSON.parse(sessionStorage.getItem('@plan')).plan,
      PreferenciaHospitalar: JSON.parse(
        sessionStorage.getItem('@preferencesData'),
      ).preferences,
      Email: sessionStorage.getItem('@email').replace(/^"|"$/g, ''),
      Cidade: sessionStorage.getItem('@city').replace(/^"|"$/g, ''),
      PlanoAnteriorNome: sessionStorage.getItem('@providerName'),
      Observacao:
        JSON.stringify(
          'Urgência: ' +
            sessionStorage.getItem('@urgency') +
            '; Método de contato: ' +
            sessionStorage.getItem('@contactMethod') +
            '; Horário de preferência: ' +
            sessionStorage.getItem('@preferredTime') +
            '; Data de video-chamada: ' +
            sessionStorage.getItem('@callDateTime'),
        ) || '',
      IdFonte: 1282,
    };

    fetch('https://api.paineldocorretor.com.br/indicacoes?hash=v0o9AP', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      body: JSON.stringify(indicacao),
    })
      .then((response) => response.json())
      .then((data) => console.log('API response:', data))
      .catch((error) => console.error('API error:', error));
  };

  const sendEmail = (emailData, isIndividual) => {
    const userID = process.env.REACT_APP_USER_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;
    const serviceID = process.env.REACT_APP_SERVICE_ID;

    const templateParams = isIndividual
      ? {
          plan: emailData.plano,
          participants: emailData.participantes,
          ageIndividual: emailData.idade,
          preferences: emailData.preferencias,
          name: emailData.nome,
          phone: emailData.telefone,
          cnpj: emailData.cnpj,
          email: emailData.email,
          city: emailData.cidade,
        }
      : {
          plan: emailData.plano,
          participants: emailData.participantes,
          age: emailData.idades,
          total: emailData.total,
          preferences: emailData.preferencias,
          name: emailData.nome,
          phone: emailData.telefone,
          cnpj: emailData.cnpj,
          email: emailData.email,
          city: emailData.cidade,
        };

    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then((result) => {
        console.log('Email enviado com sucesso:', result.text);
      })
      .catch((error) => {
        console.log('Erro ao enviar email:', error.text);
      });
  };

  const sendEmailEnd = (emailData) => {
    const userID = process.env.REACT_APP_USER_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID2;
    const serviceID = process.env.REACT_APP_SERVICE_ID;

    const templateParams = {
      plan: emailData.plano,
      participants: emailData.participantes,
      ageIndividual: emailData.idade,
      age: emailData.idades,
      total: emailData.total,
      preferences: emailData.preferencias,
      name: emailData.nome,
      phone: emailData.telefone,
      cnpj: emailData.cnpj,
      email: emailData.email,
      city: emailData.cidade,
      operator: emailData.operadora,
      choice: emailData.escolha,
      urgency: emailData.urgencia,
      contact: emailData.contato,
      preferredTime: emailData.melhorHorario,
      callDateTime: emailData.callHorario,
    };

    emailjs
      .send(serviceID, templateID, templateParams, userID)
      .then((result) => {
        console.log('Email enviado com sucesso:', result.text);
      })
      .catch((error) => {
        console.log('Erro ao enviar email:', error.text);
      });
  };

  useEffect(() => {
    if (currentPageNumber === 6) {
      const planData = JSON.parse(sessionStorage.getItem('@plan'));
      const participantsChoiceData = JSON.parse(
        sessionStorage.getItem('@participantsChoice'),
      );
      const ageData = JSON.parse(sessionStorage.getItem('@ageData'));
      const ageTotal = JSON.parse(sessionStorage.getItem('@ageTotal'));
      const preferencesData = JSON.parse(
        sessionStorage.getItem('@preferencesData'),
      );
      const fullName = JSON.parse(sessionStorage.getItem('@fullName'));
      const ageGet = JSON.parse(sessionStorage.getItem('@individualData')) || {
        age: '0',
      };
      const ageIndividual = ageGet.age;
      const phone = JSON.parse(sessionStorage.getItem('@phone'));
      const email = JSON.parse(sessionStorage.getItem('@email'));
      const cnpj = JSON.parse(sessionStorage.getItem('@cnpj'));
      const city = JSON.parse(sessionStorage.getItem('@city'));

      // Ajuste de ageData para o formato de nomes no template EmailJS
      const ages = {
        '00to18': '0',
        '19to23': '0',
        '24to28': '0',
        '29to33': '0',
        '34to38': '0',
        '39to43': '0',
        '44to48': '0',
        '49to53': '0',
        '54to58': '0',
        '59plus': '0',
      };

      // Preenchimento dos dados com base nos índices de ageData
      if (ageData) {
        ageData.forEach((item) => {
          const qty =
            typeof item.Qtd === 'string' ? item.Qtd : item.Qtd.toString();
          switch (item.IdFaixaEtaria) {
            case 0:
              ages['00to18'] = qty;
              break;
            case 1:
              ages['19to23'] = qty;
              break;
            case 2:
              ages['24to28'] = qty;
              break;
            case 3:
              ages['29to33'] = qty;
              break;
            case 4:
              ages['34to38'] = qty;
              break;
            case 5:
              ages['39to43'] = qty;
              break;
            case 6:
              ages['44to48'] = qty;
              break;
            case 7:
              ages['49to53'] = qty;
              break;
            case 8:
              ages['54to58'] = qty;
              break;
            case 9:
              ages['59plus'] = qty;
              break;
            default:
              break;
          }
        });
      }

      const emailData = {
        plano: planData.plan,
        participantes: participantsChoiceData,
        idades: ages,
        total: ageTotal,
        preferencias: preferencesData,
        nome: fullName,
        telefone: phone,
        cnpj: cnpj,
        email: email,
        cidade: city,
      };

      const emailDataIndividual = {
        plano: planData.plan,
        participantes: participantsChoiceData,
        idade: ageIndividual,
        total: ageTotal,
        preferencias: preferencesData,
        nome: fullName,
        telefone: phone,
        cnpj: cnpj,
        email: email,
        cidade: city,
      };

      if (planData.plan === 'Individual') {
        sendEmail(emailDataIndividual, true);
      } else {
        sendEmail(emailData, false);
      }
    } else if (currentPageNumber === 9) {
      const planData = JSON.parse(sessionStorage.getItem('@plan'));
      const participantsChoiceData = JSON.parse(
        sessionStorage.getItem('@participantsChoice'),
      );
      const ageData = JSON.parse(sessionStorage.getItem('@ageData'));
      const ageTotal = JSON.parse(sessionStorage.getItem('@ageTotal'));
      const preferencesData = JSON.parse(
        sessionStorage.getItem('@preferencesData'),
      );
      const fullName = JSON.parse(sessionStorage.getItem('@fullName'));
      const ageGet = JSON.parse(sessionStorage.getItem('@individualData')) || {
        age: '0',
      };
      const ageIndividual = ageGet.age;
      const phone = JSON.parse(sessionStorage.getItem('@phone'));
      const email = JSON.parse(sessionStorage.getItem('@email'));
      const city = JSON.parse(sessionStorage.getItem('@city'));
      const cnpj = JSON.parse(sessionStorage.getItem('@cnpj'));
      const providerName = JSON.parse(sessionStorage.getItem('@providerName'));
      const operatorsChoice = JSON.parse(
        sessionStorage.getItem('@operatorsChoice') || '[]',
      );
      const urgency = JSON.parse(sessionStorage.getItem('@urgency'));
      const contact = JSON.parse(sessionStorage.getItem('@contactMethod'));
      const preferredTime = JSON.parse(
        sessionStorage.getItem('@preferredTime'),
      );
      const callDateTime = JSON.parse(sessionStorage.getItem('@callDateTime'));

      // Ajuste de ageData para o formato de nomes no template EmailJS
      const ages = {
        '00to18': '0',
        '19to23': '0',
        '24to28': '0',
        '29to33': '0',
        '34to38': '0',
        '39to43': '0',
        '44to48': '0',
        '49to53': '0',
        '54to58': '0',
        '59plus': '0',
      };

      // Preenchimento dos dados com base nos índices de ageData
      if (ageData) {
        ageData.forEach((item) => {
          const qty =
            typeof item.Qtd === 'string' ? item.Qtd : item.Qtd.toString();
          switch (item.IdFaixaEtaria) {
            case 0:
              ages['00to18'] = qty;
              break;
            case 1:
              ages['19to23'] = qty;
              break;
            case 2:
              ages['24to28'] = qty;
              break;
            case 3:
              ages['29to33'] = qty;
              break;
            case 4:
              ages['34to38'] = qty;
              break;
            case 5:
              ages['39to43'] = qty;
              break;
            case 6:
              ages['44to48'] = qty;
              break;
            case 7:
              ages['49to53'] = qty;
              break;
            case 8:
              ages['54to58'] = qty;
              break;
            case 9:
              ages['59plus'] = qty;
              break;
            default:
              break;
          }
        });
      }

      const emailData = {
        plano: planData.plan,
        participantes: participantsChoiceData,
        idades: ages,
        total: ageTotal,
        preferencias: preferencesData,
        nome: fullName,
        telefone: phone,
        cnpj: cnpj,
        email: email,
        cidade: city,
        operadora: providerName,
        escolha: operatorsChoice,
        urgencia: urgency,
        contato: contact,
        melhorHorario: preferredTime,
        callHorario: callDateTime,
      };

      const emailDataIndividual = {
        plano: planData.plan,
        participantes: participantsChoiceData,
        idade: ageIndividual,
        preferencias: preferencesData,
        nome: fullName,
        telefone: phone,
        cnpj: cnpj,
        email: email,
        cidade: city,
        operadora: providerName,
        escolha: operatorsChoice,
        urgencia: urgency,
        contato: contact,
        melhorHorario: preferredTime,
        callHorario: callDateTime,
      };

      if (planData.plan === 'Individual') {
        sendApiDataIndividual();
        sendEmailEnd(emailDataIndividual);
      } else {
        sendApiData();
        sendEmailEnd(emailData);
      }
    }
  }, [currentPageNumber]);

  return <></>;
};

export default FooterSend;
